import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import _ from "lodash";
import UserDataService from "service/UserDataService";
import { DialogButton } from "Common/DialogButton";
import TaskInput from "TaskDialogCommon/TaskInput";

export default function(props) {
  const [alias, setAlias] = React.useState(null);
  const [email, setEmail] = React.useState(null);
  const [password, setPassword] = React.useState(null);

  const validate = () => {
    if (alias === null || alias === "") {
      alert("Please give your account a name.");
      return false;
    }
    if (email === null || email === "") {
      alert("Email is required");
      return false;
    }
    if (password === null || password === "") {
      alert("Password is required");
      return false;
    }
    return true;
  };

  const onSubmit = () => {
    if (!validate()) {
      return;
    }
    UserDataService.addAccount(email, password, alias);
  };

  return (
    <TaskDialog heading={"Add Account"}>
      <TaskInput
        label="Alias"
        placeholder="Give your account a name!"
        value={alias}
        onChange={(event) => {
          setAlias(event.target.value);
        }}
      />
      <TaskInput
        label="Email"
        placeholder="Hobbit account email"
        value={email}
        onChange={(event) => {
          setEmail(event.target.value);
        }}
      />
      <TaskInput
        label="Password"
        type="password"
        placeholder="Hobbit account password"
        value={password}
        onChange={(event) => {
          setPassword(event.target.value);
        }}
      />
      <DialogButton
        onClick={onSubmit}
        label="Add Account"
        style={{ marginTop: "20px" }}
      />
    </TaskDialog>
  );
}
